import styled from 'styled-components';

import {
  OFFER_CONTAINER_PADDING,
  OFFER_HEIGHT_DESKTOP,
  OFFER_HEIGHT_MOBILE,
} from 'components/offer/ui-refresh/cell-layout';

export const Title = styled.h2`
  font-family: ${Styles.fontFamily.brand};
  margin: 0;
`;
export const Body = styled.p`
  margin: 0.1rem;
  ${Styles.mobileTiny`
    font-size: 0.95rem;
  `}
`;

export const Wrapper = styled.li`
  box-sizing: unset;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${Styles.color.white};
  padding: ${OFFER_CONTAINER_PADDING};
  height: ${OFFER_HEIGHT_MOBILE};
  ${Styles.desktop`
    min-height: ${OFFER_HEIGHT_DESKTOP}
  `}
`;
